import {AUTOPLAY_QUERY_PARAM, SHOW_ID_QUERY_PARAM} from '../constants';
import {LiveShow} from '../LiveShopping/hooks/useAutoplayLiveShow';

export const pickLiveShowToAutoplay = (
  queryParameters: string,
  liveShows: LiveShow[],
) => {
  if (!liveShows || !liveShows.length) {
    return null;
  }

  const queryParams = new URLSearchParams(queryParameters);

  if (queryParams.has(AUTOPLAY_QUERY_PARAM)) {
    const showIdQueryParam = queryParams.get(SHOW_ID_QUERY_PARAM);

    if (liveShows.some(liveShow => liveShow.id === showIdQueryParam)) {
      return showIdQueryParam;
    }

    return liveShows[0].id;
  }

  const firstLiveShowId = liveShows.find(show => show.state === 'live')?.id;

  return firstLiveShowId ?? null;
};
